import React, { useEffect, useState } from 'react'
import { chipColorStyle } from 'src/Entities/RiskTypes'
import { cn, formatDate } from 'src/lib/utils'

export default function PeriodicityTabs ({ data, setSelectedData, selectedTab, setSelectedTab }) {
    const [ riskData, setRiskData ] = useState([])

    useEffect(() => {
        setRiskData(data)
    }, [data])
    return (
        <div className='w-full p-7 gap-[2px] flex flex-col'>
            {
                riskData?.map((item, i) => {
                    return (
                        <>
                            <div className='w-full flex justify-between items-center' >
                                <div className={cn(selectedTab === i ? 'border-[4px] border-[hsl(var(--muted))] scale-105' : '', 'active:scale-105 transition-transform duration-150 cursor-pointer !text-card flex items-center justify-center w-[40%] h-[64px] text-subMenu-selected font-semibold')} style={{ background: chipColorStyle(item?.riskScore) }} onClick={() => { setSelectedTab(i); setSelectedData(item) }} >{item.riskScore}</div>
                                {<img className={cn(selectedTab === i ? 'opacity-100' : 'opacity-0', 'w-[25%] transition-opacity duration-200')} src='/Assets/dotLineArrow.svg'/>}
                                <div className='text-[hsl(var(--grey))] text-menu-selected p-[23px] pl-0 font-semibold'>{formatDate(item.createdAt)}</div>
                            </div>
                        </>
                    )
                })
            }
        </div>
    )
}
